type ConfigType = {
  HOSTNAME: string | undefined;
  STRICT_MODE: boolean;
  KEYCLOAK_ENABLED: boolean;
  NATIVE_ENABLED: boolean;
  DISABLE_SSL: boolean;
  VERSION: string | undefined;
};

const Config: ConfigType = {
  HOSTNAME: process.env.REACT_APP_HOSTNAME,
  STRICT_MODE: process.env.REACT_APP_REACT_STRICT === "true",
  KEYCLOAK_ENABLED: process.env.REACT_APP_KEYCLOAK_ENABLED === "true",
  NATIVE_ENABLED: process.env.REACT_APP_NATIVE_ENABLED === "true",
  DISABLE_SSL: process.env.REACT_APP_DISABLE_SSL === "true",
  VERSION: process.env.REACT_APP_VERSION,
};

export default Config;
